export function Component(options: angular.IComponentOptions & { componentName: string }) {
  return function <T extends {new(...args: any[]): {}}>(controller: T) {
    return <T><any>Object.assign({
      controller,
    }, options);
  };
}
